module.exports = __webpack_public_path__ + "img/background25.58fad806.jpg";